module.exports = __webpack_public_path__ + "static/media/pro-white-with-color.6f62ebfe.png";